import React from 'react';
import { Select } from 'antd';

import { ClientStatus } from 'api/adminApiClient';
import { getClientStatusName } from 'utils/recruiterUtils';
import {
  ADMIN_FILTERABLE_CLIENT_STATUSES,
  isDefaultOperationalSelection,
} from '../customerClientStatusFilter';

import styles from './CustomerStatusFilter.module.less';

type Props = {
  value: ClientStatus[];
  onChange: (clientStatuses: ClientStatus[]) => void;
};

const options = ADMIN_FILTERABLE_CLIENT_STATUSES.map((status) => ({
  label: getClientStatusName(status),
  value: status,
}));

const defaultSelectionLabel = () => 'All except Deleted';

const maxTagPlaceholder = (omittedValues: unknown[]) =>
  `+${omittedValues.length}`;

export default function CustomerStatusFilter(props: Props) {
  const { value, onChange } = props;
  const isDefaultSelection = isDefaultOperationalSelection(value);

  return (
    <Select
      className={styles.statusSelect}
      mode="multiple"
      value={value}
      options={options}
      placeholder="Customer status"
      optionFilterProp="label"
      maxTagCount={isDefaultSelection ? 0 : 1}
      maxTagPlaceholder={
        isDefaultSelection ? defaultSelectionLabel : maxTagPlaceholder
      }
      onChange={onChange}
    />
  );
}
